import { cn } from '@/utils/shad';
import { WithBaseElementGlobalAttributes } from '@/types/component';

type Variant = 'rectangular';

type Props = WithBaseElementGlobalAttributes & {
  variant?: Variant;
  // in em
  width?: number;
  // in em
  height?: number;
  fullWidth?: boolean;
};

export function LoadingSkeleton({
  variant = 'rectangular',
  width = 7,
  fullWidth,
  height = 1,
  className,
  ...rest
}: Props) {
  if (variant === 'rectangular')
    return (
      <div
        role="status"
        title="loading..."
        className={cn('animate-pulse rounded-md bg-neutral-800', className)}
        style={{
          width: fullWidth ? '100%' : `${width}em`,
          height: `${height}em`,
        }}
        {...rest}
      />
    );
}
